import { useRoutes } from "react-router-dom";
import Home from "./pages/Home";
import Test from "./pages/test/test";
import Tag from "./pages/Tag";

import { modulo14 } from "./routes/Module14";
import { modulo1 } from "./routes/Module1";
import { modulo2 } from "./routes/Module2";
import { modulo3 } from "./routes/Module3";
import { modulo4 } from "./routes/Module4";
import { modulo5 } from "./routes/Module5";
import { modulo6 } from "./routes/Module6";
import { modulo7 } from "./routes/Module7";
import { modulo8 } from "./routes/Module8";
import { modulo9 } from "./routes/Module9";
import { modulo10 } from "./routes/Module10";
import { modulo11 } from "./routes/Module11";
import { modulo12 } from "./routes/Module12";
import { modulo13 } from "./routes/Module13";

export const paths = {}

export const modules = [
 modulo1, modulo2, modulo3, modulo4, modulo5, modulo6, modulo7, modulo8, modulo9, modulo10, modulo11, modulo12, modulo13, modulo14
];
const ListRoutes = () => {

    let modulesRoutes = modules.map(module => (
      {
        path: module.url,
        children: [
          {
            path: "",
            element: module.component
          },
          {
            path: "cierre",
            element: module.conclusion
          },
            ...module.content.map(unidad => (
              {
                path: unidad.path,
                element: unidad.element,
                children: [
                  ...unidad.activities.map(act => (
                    {
                      path: act.path,
                      element: act.component
                    }
                  ))
                ]
              }
            ))
          
        ]
      }
    ))

    let routesBook = [
      {
        path: '/',
        element: <Home />,
        title: "Modulos de aprendizaje Nuestro País"
      },
      {
        path: '/:tag',
        element: <Tag />,
        title: "Modulos de aprendizaje Nuestro País"
      },
      {
        path: '/test',
        element: <Test />,
        title: "Modulos de aprendizaje Nuestro País"
      },
      ...modulesRoutes
    ];
    let routesList = useRoutes(routesBook);
    return routesList;
  };

export default ListRoutes;